import * as route from "./route";
import * as module from "./module";
import * as sync from "./sync";
import { IModuleOptions } from '@/utils/IModuleOptions';

export default {
  modulename: "logs",
  module, route, sync, 
  roles: ["Amministratore"]
} as IModuleOptions